<template>
  <ITMPage>
    <DataTableAsync class="mt-3" :data="tableData" v-model="tableState" :length="(data || []).length" noSearch ref="dataTable">
      <template #menu>
        <div class="hvh-flex align-center" v-if="isAdmin">
          <v-btn flat class="hvh-btn hvh-btn--secondary" @click="orderForEdit = {}">Add</v-btn>
        </div>
      </template>
      <template #head>
        <tr>
          <Th prop="primaryCustomer?.facilityName" sort>Customer Company</Th>
          <Th prop="orderId" sort>PO #</Th>
          <Th prop="orderDate" sort>Date</Th>
          <Th prop="primaryCustomer?.email" sort>Contact</Th>
          <th />
        </tr>
      </template>
      <template #body="{ item }">
        <tr>
          <td>{{ (item.primaryCustomer || {}).facilityName }}</td>
          <td>{{ item.orderId }}</td>
          <td>{{ dateFormat(item.orderDate) || '-' }}</td>
          <td>{{ (item.primaryCustomer || {}).email }}</td>
          <td class="text-center">
            <v-icon @click="orderForEdit = item">{{ isAdmin ? 'mdi-pencil' : 'mdi-eye' }}</v-icon>
          </td>
        </tr>
      </template>
    </DataTableAsync>
    <Loader v-if="isLoading" />

    <ITMCreateOrder :value="orderForEdit" :isLoading="isLoading" :readOnly="!isAdmin" @input="orderForEdit.id ? editOrder($event) : addOrder($event)" @close="orderForEdit = null" v-if="orderForEdit" />
  </ITMPage>
</template>

<script>
import axios from '../../axios'
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue'
import Th from '../../components/common/dataTable/Th.vue'
import Loader from '../../components/common/loader/Loader.vue'
import ITMCreateOrder from '../../components/itm/ITMCreateOrder.vue'
import ITMPage from '../../components/itm/ITMPage.vue'
import { customNumberFormat, errorDebug } from '../../libraries/common'
export default {
  components: { Loader, ITMPage, DataTableAsync, Th, ITMCreateOrder, },
  data() {
    return {
      data: null,
      tableState: { page: 1, perPage: 25 },
      isLoading: false,
      orderForEdit: null,
    };
  },
  computed: {
    sortedData() {
      var response = (this.data || []);

      if (this.tableState.sortByProp) {
        response = response.sortBy(this.tableState.sortByProp);
        if (this.tableState.sortDirection === 'desc')
          response = response.reverse();
      }
      return response;
    },
    tableData() {
      return this.sortedData
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    isAdmin() {
      return this.$store.state.user.isMainAdmin || this.$store.state.user.isAdmin;
    },
  },
  methods: {
    getData() {
      this.isLoading = true;
      axios.get(`/api/ITM/Orders`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
    addOrder(order) {
      this.isLoading = true;
      axios.post('/api/ITM/Orders', order)
        .then(() => {
        axios.get(`/api/ITM/Orders`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.orderForEdit = null)
        .then(() => this.isLoading = false);
        })
    },
     editOrder(order) {
      this.isLoading = true;
      axios.put(`/api/ITM/Orders/${order.id}`, order)
        .then(() => {
          axios.get(`/api/ITM/Orders`)
        .then(({ data }) => this.data = data)
        .catch(errorDebug)
        .then(() => this.orderForEdit = null)
        .then(() => this.isLoading = false);
        })
        
    },
    // saveDocuments(orderId, documents) {
    //   var order = this.data.find(f => f.id === orderId);
    //   this.$set(order, 'documents', documents.filter(f => f.id || !f.deleted));

    //   var postDocs = order.documents
    //     .filter(f => !f.id)
    //     .map(f => axios.post(`/api/ITM/Documents`, toFormData({ ...f, orderId: orderId, }))
    //       .then(({ data }) => order.documents.replace(f, data))
    //       .catch(errorDebug));

    //   var deleteDocs = order.documents
    //     .filter(f => f.deleted)
    //     .map(f => axios.delete(`/api/ITM/Documents/${f.id}`)
    //       .then(() => order.documents.remove(f))
    //       .catch(errorDebug));


    //   return Promise.all([...postDocs, ...deleteDocs]);
    // },
    customNumberFormat,
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMOrders'] = this;
    this.getData();
  },
}
</script>

<style lang="scss" scoped>
.link {
  color: #002f6c;
  border-bottom: 1px solid #002f6c;
  cursor: pointer;
}
</style>